<template>
  <div>
    <div v-if="listIsEmpty">
      <div v-if="collectList.length > 0">
        <div
          class="goods-item"
          v-for="(item, index) in collectList"
          :key="index"
        >
          <div class="img-box">
            <img
              class="c-pointer"
              v-lazy="item.goodsImage ? item.goodsImage : $defaultImg"
              alt=""
              @click="toDetail(item)"
            />
          </div>
          <div class="base-info l1">
            <p class="p1">
              <span class="c-pointer" @click="toDetail(item.goodsId)">{{
                item.goodsName
              }}</span>
            </p>
            <p class="p2">厂家：{{ item.goodsManufacturer }}</p>
          </div>
          <!-- <div class="desc l2">{{item.goodsId}}</div> -->
          <div class="desc l2">{{ item.goodsSpecification }}</div>

          <div class="price-box l3">
            <span class="span1">￥{{ item.goodsPriceStr }}</span>
            <span class="span2"></span>
          </div>
          <div class="other">
            <!-- <div class="cart">
              <number-input ref="inputNumber"></number-input>
              <span class="add-cart" @click="add(item, index)">加入购物车</span>
            </div> -->
            <div class="del c-pointer" @click="delCollect(item.goodsId, index)">
              <span>删除</span>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          @current-change="changepage"
          :total="total"
          :current-page="pageNumber"
          v-if="collectList.length"
        >
        </el-pagination>
      </div>
      <div v-else class="empty">
        <div class="empty-img">
          <img :src="require('@/assets/images/shouc.png')" alt="" />
        </div>
        <span>暂无收藏</span>
      </div>
    </div>
    <success v-if="successShow"> {{ message }}</success>
    <toast ref="toast"></toast>
  </div>
</template>
<script>
import numberInput from "@/components/input-number.vue";
export default {
  components: { numberInput },
  data() {
    return {
      listIsEmpty: false,
      collectList: [],
      pageNumber: 1,
      pageSize: 8,
      total: "",
      successShow: false,
      message: "",
    };
  },

  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/detail",
        query: { goodsId: item.goodsId, type: 1 },
      });
      this.ANALYSISSAVE(item, 2);
    },
    //取消收藏
    delCollect(id, index) {
      //console.log(id);
      this.$api
        .POST_CANCELCOLLECT({
          goodsId: id,
        })
        .then((res) => {
          if (res.status) {
            this.$refs.toast.info = { title: "删除成功", type: "success" };
            this.$refs.toast.isShow();
            this.collectList.splice(index, 1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    add(item, index) {
      let num = this.$refs.inputNumber[index].number;
      let id = item.goodsId;
      //console.log(item,num)
      this.$api
        .POST_ADDCART({
          cartItemType: "goods", //combination
          id,
          quantity: num,
        })
        .then((res) => {
          //console.log(res);
          if (res.status) {
            this.successShow = true;
            this.message = "加购成功";
            this.$store.commit(
              "GETCARTCOUNT",
              Number(this.$store.state.cartNum) + Number(num)
            );
            this.ANALYSISSAVE(item, 1);
          } else {
            this.$refs.toast.info = { title: res.message, type: "fail" };
            this.$refs.toast.isShow();
          }
        });
    },
    success() {
      this.successShow = false;
    },
    changepage(val) {
      this.pageNumber = val;
      this.getCollectList();
    },
    getCollectList() {
      //获取收藏列表
      this.$api
        .GET_COLLECTLIST({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.status) {
            this.collectList = res.data;
            this.total = res.totals;
            this.listIsEmpty = true;
          }
        });
    },
    // 数据分析
    ANALYSISSAVE(gooodsDetail, savetype) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let goodsName = gooodsDetail.name;
      let title;
      let type;
      let url;
      if (savetype == 1) {
        (title = "加入购物车"), (type = "cart");
      } else {
        (title = "访问商品"), (type = "detail");
      }
      (type = "cart"),
        (url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`);
      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodId,
          goodsName,
        })
        .then((res) => {
          //console.log(res);
        })
        .catch((err) => console.log(err));
    },
  },
  created() {
    this.getCollectList();
  },
};
</script>
<style lang="scss" scoped>
.goods-item {
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  width: 893px;
  height: 128px;
  padding-left: 32px;
  display: flex;
  align-items: center;
  .img-box {
    margin-right: 18px;
    img {
      width: 94px;
      height: 94px;
    }
  }
  .base-info {
    .p1 {
      color: #505050;
      margin-bottom: 34px;
      padding-right: 64px;
    }
    .p2 {
      color: #999999;
    }
  }
  .desc {
    color: #808080;
    margin-right: 20px;
  }
  .price-box {
    .span1 {
      color: #fa4b4b;
      font-weight: 600;
    }
    .span2 {
      color: #808080;
    }
  }
  .other {
    position: absolute;
    right: 0px;
  }
  .cart {
    float: left;
    height: 98px;
    @include flex-d-c;
    .add-cart {
      width: 112px;
      display: inline-block;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
      background: #fa4b4b;
      cursor: pointer;
      border-radius: 4px;
      margin-top: 12px;
    }
  }
  .del {
    margin-left: 28px;
    float: left;
    width: 30px;
    padding: 0 8px;
    height: 98px;
    display: flex;
    align-items: center;
    background: #fafafa;
    text-align: center;
    color: #808080;
  }

  .l1 {
    margin-right: 60px;
    width: 220px;
  }
  .l2 {
    width: 140px;
  }
  .l3 {
    width: 140px;
  }
}
.pagination {
  text-align: center;
  margin-top: 40px;
  color: #fa4b4b;
}
.empty {
  align-items: center;
  margin-top: 140px;
  @include flex-d-c;
  .empty-img {
    margin-bottom: 15px;
  }
  span {
    font-size: 18px;
    color: #333333;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/person/components/person-collect/goods-item-ceil.vue